
const navBar={
  // namespaced:true,
  state: {
    nav:[]
  },
  getters: {
    navData: state => state.nav
  },
  mutations: {
    setnav(state, data) {//设置导航信息
      state.nav = data;
    },
    resetNav(state, data) {//重置
      // window.sessionStorage.removeItem('navBar');
      // console.log('nav重置',data)
      state.nav = data||[];
    }
  },
  actions: {// 管理mutations
    SETNAV(context, data) {//添加导航信息
      // console.log('放入数据了：：',data)
      context.commit('setnav', data);
    },
    RESETNAV(context, data) {//添加导航信息
      // console.log('放入数据了：：',data)
      context.commit('resetNav', null);
    }
  }
}
export default navBar;



// WEBPACK FOOTER //
// ./src/store/navBar.js